const defaultLocale = "it"

const i18nPath = {
  it: {
    category: "categoria",
    search: "cerca",
    products: "prodotti",
    reference: "referenze",
    guides: "guide",
  },
  en: {
    reference: "references",
    category: "category",
    search: "search",
    products: "products",
    guides: "guides",
  },
  de: {
    reference: "references",
    category: "kategorie",
    search: "suche",
    products: "produkte",
    guides: "leitfaden",
  },
  fr: {
    reference: "references",
    category: "categorie",
    search: "recherche",
    products: "produits",
    guides: "guides",
  },
  "en-US": {
    category: "category",
    search: "search",
    products: "products",
    guides: "guides",
  },
}

export function getPagePath(page, locale) {
  const pageLocale = locale || page.locale
  let lang =
    pageLocale === defaultLocale ? "/" : `/${pageLocale.toLowerCase()}/`
  let path = `${page._allSlugLocales.find(x => x.locale === pageLocale).value}`
  if (page.root) {
    return lang + `${path}/`
  }

  path = `${
    page.treeParent._allSlugLocales.find(x => x.locale === pageLocale).value
  }/${path}`
  if (page.treeParent.root) {
    return lang + `${path}/`
  }
  path = `${
    page.treeParent.treeParent._allSlugLocales.find(
      x => x.locale === pageLocale
    ).value
  }${path}`
  return lang + `${path}/`
}

export function getHomePath(locale) {
  // console.log(locale)
  return locale === defaultLocale ? "/" : `/${locale.toLowerCase()}/`
}

export function getSearchPath(locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].search}/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].search}/`
}

export function getBlogPath(locale) {
  return locale === defaultLocale ? `/blog/` : `/${locale.toLowerCase()}/blog/`
}

export function getGuidesPath(locale) {
  return locale === defaultLocale ? `/${i18nPath[locale].guides}/` : `/${locale.toLowerCase()}/${i18nPath[locale].guides}/`
}

export function getPolicyPath(page, locale) {
  return locale === defaultLocale
    ? `/policy/${page.slug}/`
    : `/${locale.toLowerCase()}/policy/${page.slug}/`
}

export function getArticleCategoryPath(page, locale) {
  return locale === defaultLocale
    ? `/blog/${i18nPath[locale].category}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
    : `/${locale.toLowerCase()}/blog/${i18nPath[locale].category}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}

export function getCategoryPath(page, locale) {
  return page.locale === defaultLocale
    ? `/${i18nPath[page.locale].category}/${page.slug}/`
    : `/${page.locale}/${i18nPath[page.locale].category}/${page.slug}/`
}

export function getArticlePath(page, locale) {
  const path =
    page.category.originalId === "A_D_owA8S-6LPp_E7ih0QQ"
      ? "blog"
      : i18nPath[page.locale.toLowerCase()].guides
  return locale === defaultLocale
    ? `/${path}/${page._allSlugLocales.find(x => x.locale === locale).value}/`
    : `/${locale.toLowerCase()}/${path}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}

export function getSingleReferencePath(locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].reference}/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].reference}/`
}

export function getReferencePath(page, locale) {
  // console.log(page, locale)
  return locale === defaultLocale
    ? `/${i18nPath[locale].reference}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].reference}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}

export function getProductPath(page, locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].products}/${page.slug}/`
    : `/${locale.toLowerCase()}/${i18nPath[page.locale].products}/${page.slug}/`
}
